import React from 'react'
import "./Sec4Evolution.css"
import Img from "../../Images/Graph.png"

function Sec4Evolution() {
  return (
        <div className="Sec4Evolution-container container">
          <h3 className="Sec4Evolution-title">GCC Evolution in India</h3>
          <div className='Sec4Evolution-sub-container'>
                <div className="Sec4Evolution-content-container">
                    <p className="Sec4Evolution-content-container-subtitle text">This impressive growth trajectory is underpinned by a robust framework that India has meticulously developed. <h2>India’s moniker, “the GCC capital,” is not just a title; it’s a testament to the foundation of 3Vs – Volume, Value, and Velocity that defines the work conducted here.</h2> With the Indian GCC ecosystem consistently growing at about 6% each year, it’s no wonder organizations are eager to tap into such a thriving environment. But what are the key elements that fuel this success? </p>
                </div>
                <div className="Sec4Evolution-image-container">
                    <img src={Img} alt="India Redefining the Globalization Blueprint" className="image" />
                </div>
          </div>
        </div>
      );
}

export default Sec4Evolution
